export default __webpack_public_path__ + "static/media/photo--sm--130.4dd9fb53.jpg";